// extracted by mini-css-extract-plugin
module.exports = {"section1Container":"Section1_section1Container__AxU9X","itemContainer":"Section1_itemContainer__YrY8q","itemRow":"Section1_itemRow__yu4MN","item":"Section1_item__mx1Dy"};